











import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { IObjectsControllable, ILinkedPageObjectSpecifiable } from "../../../../domain/format/objects";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";

@Component
export default class EmptyAlertAllowBehaviorEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IObjectsControllable<ILinkedPageObjectSpecifiable>) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IObjectsControllable<ILinkedPageObjectSpecifiable>) => T, defaultValue: T) => T;

  @Prop()
  commonComponents: CommonComponentsContainer;

  get targets(): ILinkedPageObjectSpecifiable[] {
    return this.readPropertyOrDefault(s => s.targets, []);
  }

  set targets(value: ILinkedPageObjectSpecifiable[]) {
    this.writePropertyWhenValid(s => s.targets = value);
  }

  get selectionObjects(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .where(o => this.conditionsOfEachElementType(o))
        .select(o => this.toLinkedPageObjectSpecifiable(o, p.pageKey))
        .toArray())
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    return !object.isSelected() && this.isSelectableObject(object) && !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
  }

  private isSelectableObject(object: IFormatObjectEditable) {
    switch (object.objectTypeName().getValue()) {
      case "text":
      case "tag":
      case "date":
      case "combo":
      case "roll":
      case "script":
      case "scriptlink":
      case "richText":
        return true;
      default:
        return false;
    }
  }

  private toLinkedPageObjectSpecifiable(object: IFormatObjectEditable, pageKey: number): ILinkedPageObjectSpecifiable {
    const linkedObject = object.toLinkedObjectIdentifier();
    return {
      pageKey: pageKey,
      type: linkedObject.type,
      id: linkedObject.id,
      key: linkedObject.key,
      subKey: linkedObject.subKey,
      tableIndex: linkedObject.tableIndex,
      isDate: linkedObject.isDate,
    };
  }
  async showObjectSelectDialog() {
    const dialog = this.commonComponents.getDialogs().getFormatObjectSelectDialog();
    const selectedObjects = await dialog.show(
      this.targets,
      this.selectionObjects,
      ["selection", "index", "type", "key", "id", "pageNumber"],
      ["selection", "type", "key", "id", "pageNumber"],
      false,
      true,
      [
        { enabled: false, name: "テキスト", description: "テキストで絞り込みします", filter: v => v.type === "text" || v.type === "tag" || v.type === "scriptlink" },
        { enabled: false, name: "日付", description: "日付で絞り込みします", filter: v => v.type === "date" && v.isDate === true },
        { enabled: false, name: "時間", description: "時間で絞り込みします", filter: v => v.type === "date" && v.isDate === false },
        { enabled: false, name: "リスト", description: "リストで絞り込みします", filter: v => v.type === "combo" },
        { enabled: false, name: "クリック", description: "クリック選択で絞り込みします", filter: v => v.type === "roll" },
        { enabled: false, name: "外部データ", description: "外部データで絞り込みします", filter: v => v.type === "script" },
      ],
      this.toCellString);
    if (!selectedObjects) { return; }
    this.targets = selectedObjects;
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable): string {
    const formatObject = this.getFormatObjectEditable(row);
    switch (column) {
      case "type":
        return formatObject ? formatObject.getTypeName() : "";
      case "key":
        return formatObject && formatObject.getIdentifiableName()
          ? formatObject.getIdentifiableName()
          : row.key;
      case "id":
        return row.id ? row.id.toString() : "";
      case "pageNumber":
        const pageNumber = this.commonComponents.getPageNumber(row.pageKey);
        return pageNumber === 0 ? "削除済" : pageNumber.toString();
      default:
        return "";
    }
  }

  private getFormatObjectEditable(row: ILinkedPageObjectSpecifiable): IFormatObjectEditable {
    const pageFormatObjects = this.commonComponents.allPagesFormatObjectsForEachPage.find(p => p.pageKey === row.pageKey);
    if (!pageFormatObjects) {
      return null;
    }
    const rRow = row.tableIndex ? row.tableIndex.row : null;
    const rColumn = row.tableIndex ? row.tableIndex.column : null;
    return Enumerable.from(pageFormatObjects.objects)
      .firstOrDefault(o => {
        const linkedObject = o.toLinkedObjectIdentifier();
        const linkedRow = linkedObject.tableIndex ? linkedObject.tableIndex.row : null;
        const linkedColumn = linkedObject.tableIndex ? linkedObject.tableIndex.column : null;
        return linkedObject.type === row.type &&
          linkedObject.id === row.id &&
          linkedObject.key === row.key &&
          linkedObject.subKey === row.subKey &&
          linkedRow === rRow &&
          linkedColumn === rColumn &&
          linkedObject.isDate === row.isDate;
      });
  }
}
